import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, ChevronDownIcon, EllipsisIcon, GlobeIcon, MessageCircleIcon, PlayIcon, Share2Icon, ThumbsUpIcon } from "lucide-react";
import { ReactionIcons } from "./ReactionIcons";
import { CommentItem } from "./CommentItem";
import { extraComments, facebookComments, facebookPost } from "../../data/facebookComments";
export function FacebookPost() {
  const [liked, setLiked] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const reactions = facebookPost.reactions + (liked ? 1 : 0);
  return <article className="mx-auto w-full max-w-[640px] overflow-hidden rounded-xl bg-white font-[system-ui] shadow-[0_20px_60px_-25px_rgba(0,0,0,0.35)] ring-1 ring-black/5" data-id="element-23" data-mp="2zjlaeyutynay">
      <header className="flex items-center gap-2 px-4 pt-3" data-id="element-24" data-mp="xrpzilgeemts">
        <img src={facebookPost.avatar} alt="" className="h-10 w-10 rounded-full object-cover ring-1 ring-black/10" data-id="element-25" data-mp="xs83k49ay5c9" />
        <div className="flex-1" data-id="element-26" data-mp="11qpekyvufzyy">
          <p className="flex items-center gap-1 text-[15px] font-semibold text-fb-text" data-id="element-27" data-mp="3u8iswhjderrk">
            {facebookPost.page}
            <BadgeCheckIcon className="h-4 w-4 fill-fb-blue text-white" aria-label="Verificada" data-id="element-28" data-mp="3p969y7vme4u9" />
          </p>
          <p className="flex items-center gap-1 text-xs text-fb-muted" data-id="element-29" data-mp="7swsorbxk0c1">
            {facebookPost.time} · <GlobeIcon className="h-3 w-3" data-id="element-30" data-mp="2voawrup1ybb" />
          </p>
        </div>
        <EllipsisIcon className="h-5 w-5 text-fb-muted" aria-hidden data-id="element-31" data-mp="3b9dano612gao" />
      </header>

      <p className="px-4 py-3 text-[15px] leading-snug text-fb-text" data-id="element-32" data-mp="36bbt57o92p1b">{facebookPost.text}</p>

      <div className="relative" data-id="element-33" data-mp="3l82uhmhhiatk">
        <img src={facebookPost.video} alt="Video: brownie sin azúcar en 15 minutos" className="aspect-video w-full object-cover" data-id="element-34" data-mp="3l9dvxfngj6hi" />
        <div className="absolute inset-0 bg-black/25" data-id="element-35" data-mp="3g7ycfs0xh818" />
        <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-black/55 ring-2 ring-white/80" data-id="element-36" data-mp="10hc3f1o13whk">
          <PlayIcon className="ml-1 h-7 w-7 fill-white text-white" data-id="element-37" data-mp="12mh4pb1bonh3" />
        </span>
        <span className="absolute bottom-3 left-3 rounded bg-black/70 px-1.5 py-0.5 text-xs font-semibold text-white" data-id="element-38" data-mp="12ol4phw3p2c3">{facebookPost.duration}</span>
        <span className="absolute bottom-3 right-3 rounded bg-black/70 px-1.5 py-0.5 text-xs text-white" data-id="element-39" data-mp="1clg6c9no7iul">{facebookPost.views}</span>
      </div>

      <div className="flex items-center justify-between px-4 py-2.5 text-[15px] text-fb-muted" data-id="element-40" data-mp="1hh57ghfc97t0">
        <span className="flex items-center gap-1.5" data-id="element-41" data-mp="jtmqwkffr1eg">
          <ReactionIcons types={["like", "love", "haha"]} data-id="element-42" data-mp="ovvknj04u7hm" />
          {(reactions / 1000).toFixed(1).replace(".", ",")} mil
        </span>
        <span data-id="element-43" data-mp="tru1mlj4sn80">
          {facebookPost.comments} comentarios · {facebookPost.shares} veces compartido
        </span>
      </div>

      <div className="mx-4 grid grid-cols-3 border-y border-fb-line/70 py-1 text-[15px] font-semibold text-fb-muted" data-id="element-44" data-mp="15hopheffohr">
        <button type="button" onClick={() => setLiked(v => !v)} aria-pressed={liked} className={`flex items-center justify-center gap-2 rounded-md py-1.5 transition-colors duration-150 hover:bg-fb-bg ${liked ? "text-fb-blue" : ""}`} data-id="element-45" data-mp="63j8k4jofrua">
          <motion.span animate={liked ? {
          scale: [1, 1.3, 1]
        } : {
          scale: 1
        }} transition={{
          duration: 0.25
        }} className="inline-flex" data-id="element-46" data-mp="2adny45is3az5">
            <ThumbsUpIcon className={`h-5 w-5 ${liked ? "fill-fb-blue" : ""}`} data-id="element-47" data-mp="25e1hrn7nlem4" />
          </motion.span>
          Me gusta
        </button>
        <span className="flex items-center justify-center gap-2 py-1.5" data-id="element-48" data-mp="20hkwr1vr3gd9">
          <MessageCircleIcon className="h-5 w-5" data-id="element-49" data-mp="1vnqcnxc8gzdn" /> Comentar
        </span>
        <span className="flex items-center justify-center gap-2 py-1.5" data-id="element-50" data-mp="1rohjatl3v3im">
          <Share2Icon className="h-5 w-5" data-id="element-51" data-mp="1mov6gl96vpac" /> Compartir
        </span>
      </div>

      <div className="px-4 pb-5 pt-3" data-id="element-52" data-mp="1hp8suapg8710">
        <p className="mb-4 flex items-center gap-1 text-[15px] font-semibold text-fb-muted" data-id="element-53" data-mp="1ho779cat4251">
          Más relevantes <ChevronDownIcon className="h-4 w-4" data-id="element-54" data-mp="1crgp8jffywgz" />
        </p>
        <div className="space-y-5" data-id="element-55" data-mp="3csoqwacqwqlw">
          {facebookComments.map(c => <CommentItem key={c.id} comment={c} data-id="element-56" data-mp="3curfqr25wdp1" />)}
          <AnimatePresence initial={false} data-id="element-57" data-mp="3hq6sffofo3jv">
            {showMore && extraComments.map((c, i) => <motion.div key={c.id} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.2,
            delay: i * 0.05
          }} data-id="element-58" data-mp="332byjvyovt57" data-mpi={i}>
                  <CommentItem comment={c} data-id="element-59" data-mp="2z0qki7af58tf" />
                </motion.div>)}
          </AnimatePresence>
        </div>
        {!showMore && <button type="button" onClick={() => setShowMore(true)} className="mt-5 text-[15px] font-semibold text-fb-muted transition-colors duration-150 hover:underline" data-id="element-60" data-mp="2k5kgfpuvvk2q">
            Ver más comentarios
          </button>}
      </div>
    </article>;
}